import classNames from "classnames";

import styles from "./UI.module.css";

const GAP_CLASS = {
    0.5: styles.gap0_5,
    1: styles.gap1,
    2: styles.gap2,
    3: styles.gap3,
};

const ALIGN_CLASS = {
    center: styles.alignCenter,
    start: styles.alignStart,
    stretch: styles.alignStretch,
};

const JUSTIFY_CLASS = {
    center: styles.justifyCenter,
    between: styles.justifyBetween,
};

const MT_CLASS = {
    1: styles.mt1,
    2: styles.mt2,
    3: styles.mt3,
};

/**
 * Flex container, replacing MUI's <Stack>.
 *
 * Deliberately takes an enumerated set of props rather than MUI's `sx`: `sx`
 * values are resolved at render time and delivered as an injected <style>, which
 * `style-src 'self'` blocks. Anything these props don't cover belongs in the
 * calling component's own CSS module, passed in via `className`.
 */
export function Stack({
    align,
    as: Component = "div",
    children,
    className,
    direction = "column",
    fullWidth = false,
    gap,
    justify,
    mt,
    ...rest
}) {
    return (
        <Component
            className={classNames(
                styles.stack,
                direction === "row" && styles.stackRow,
                GAP_CLASS[gap],
                ALIGN_CLASS[align],
                JUSTIFY_CLASS[justify],
                MT_CLASS[mt],
                fullWidth && styles.fullWidth,
                className,
            )}
            {...rest}
        >
            {children}
        </Component>
    );
}

/** `flat` swaps MUI's elevation-1 shadow for the custom one the primary cards used. */
export function Card({ children, className, flat = false, ...rest }) {
    return (
        <div
            className={classNames(styles.card, flat && styles.cardFlat, className)}
            {...rest}
        >
            {children}
        </div>
    );
}

export function Divider({ className, ...rest }) {
    return <hr className={classNames(styles.divider, className)} {...rest} />;
}
